import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { app } from "../config";

export const functions = getFunctions(app);

if (process.env.REACT_APP_PROJECT_ID === "assindatcolf-recruit-dwh-devop") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}
